module.exports = __webpack_public_path__ + "img/16.8d990b43.png";